import React, { FC } from "react";
import { Card, Title } from "@skyportal/ui-kit";
import { useTranslation } from "react-i18next";
import BucketsTable from "./tables";

import styles from "./BucketsPageContent.module.css";

const BucketsPageContent: FC = () => {
  const { t } = useTranslation("storageOverview");
  return (
    <Card
      title={
        <div className={styles.titleContainer}>
          <Title level={5}>{t("table.title")}</Title>
        </div>
      }
      className={styles.card}
    >
      <BucketsTable />
    </Card>
  );
};

export default BucketsPageContent;
